import React, { type FC } from "react";

import { GradeSelectorMemoLabel } from "../../../utils/labels";
import Slider from "./slider/Slider";
import { selectModel } from "../../../redux/slices/GradeSelectorModelSlice";
import { useGradeSelectorSelector } from "../../../redux/hooks";
import Text from "../../../../shared-components/css-modules/lexus/atoms/Text";
import Container from "../../../../shared-components/css-modules/lexus/atoms/Container";
import styles from "./selector.module.scss";
import ExchangeRate from "./exchange-rate/ExchangeRate";
import Disclaimers from "./disclaimers/Disclaimers";
import { useComponentRegistry } from "../componentRegistry";

const Selector: FC = () => {
    const { name } = useGradeSelectorSelector(selectModel);
    const BackToModel = useComponentRegistry("BackToModel");

    return (
        <section className={styles.wrapper}>
            <BackToModel />
            <Container>
                <Text tag="h2" variant="apheleia-h3" className={styles.slidertitle}>
                    <GradeSelectorMemoLabel label="gradeSelectorMainTitle" params={{ model: name }} useHTML />
                </Text>
                <Text tag="h3" spacing="spacing-4" className={styles.slidersubtitle}>
                    <GradeSelectorMemoLabel label="gradeSelectorMainSubtitle" useHTML />
                </Text>
            </Container>
            <Slider />
            <Container>
                <ExchangeRate />
            </Container>
            <Container>
                <Disclaimers />
            </Container>
            <Container>
                <div className="section gf-inpage-gradeselector" />
            </Container>
        </section>
    );
};

export default Selector;
